<template>
  <div @click="$emit('click')" :class="{'td4-body-bg':tdType == 'body'}" class="my-td4-box" :style="'width:' + boxWidth">
    <div class="my-td4-box-inner" ref="td">
      <slot></slot>
    </div>
  </div>
</template>
<script>
// <Td4></Td4>
// 标题 150 内容 307
export default {
  name: 'Td4',
  props: {
    width: {
      type: String,
      default: '0'
    },
    tdType: {
      type: String,
      default: 'body'
    },
    bgWidth: {
      type: String,
      default: '50%'
    }
  },
  computed: {
    boxWidth () {
      let width = 0
      // tdType
      // body title

      if (this.tdType === 'title') {
        if (Number(this.width) > 0) {
          width = this.width
          return width + 'px;'
        }
        return width + 'px;'
      }
      if (this.tdType === 'body') {
        if (Number(this.width) > 0) {
          width = this.width
        }
        return 'calc(' + this.bgWidth + ' - ' + width + 'px);'
      }
      // 标题 150 内容 307

      return width
    }
  },
  data () {
    return {

    }
  },

  methods: {
    // handleClick (evt) {
    //   this.$emit('click', evt)
    // }
  },
  mounted () {
    // let td = this.$refs.td
    // let height = window.getComputedStyle(td).height
    // let num = height.substr(0, height.length - 2)
    //
    // let tdHeight = document
    // )
    // my-td4-box-inner
    // document.getElementBy
  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-td4-box{
  vertical-align: top;
  box-sizing:border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  font-size:14px;
  font-weight:400;
  color:rgba(102,102,102,1);

  display: inline-block;
  line-height: 36px;
  padding: 18px 0px;
  margin: 0 auto;
  min-height: 54px;
  // height: 100%;
  border-left:1px solid rgba(223,228,234,1);
  &:nth-child(1){
    border-left:0px ;
  }
  &:last-child{
    // border-right:0;
    // border-right:1px solid rgba(223,228,234,1);
  }
  .my-td4-box-inner{
    box-sizing:border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding: 0 20px;
  }
}
.td4-body-bg{
  background:#fff;
  line-height: 18px;
}
</style>
